import { render } from "./user-image.vue?vue&type=template&id=65c47bb9&ts=true"
import script from "./user-image.vue?vue&type=script&lang=ts"
export * from "./user-image.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__